import gql from 'graphql-tag';

export default gql`
  subscription onUpdateOrder {
    onUpdateOrder {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/UpdateOrderSubscription.ts